import React from 'react'

import TextField from 'components_new/atoms/TextField'

import { BOARD } from './accents'

interface NameFieldProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

/**
 * Compact free-text input for naming a new output column, sized to sit level
 * with the board's field rows (Concatenate, Unite).
 */
const NameField = (props: NameFieldProps) => {
  const { value, onChange, placeholder } = props

  return (
    <TextField
      className={'nodrag ignore-locked-mode'}
      noGutter={true}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder ?? 'Namn'}
      size="small"
      value={value}
      sx={{
        // doubled class names beat the generic overrides that the TextField
        // atom applies after consumer sx
        '& .MuiInputBase-root.MuiInputBase-root': {
          backgroundColor: 'common.white',
          border: `1px solid ${BOARD.border}`,
          borderRadius: '9px'
        },
        '& input': {
          color: BOARD.textPrimary,
          fontFamily: BOARD.fontBody,
          fontSize: '12.5px',
          padding: '5px 8px'
        }
      }}
    />
  )
}

export default NameField
